import axios from "axios";
import {authManager} from "@zhoujianhui/vip-core";

const btnResourceManager = {
    permissions: [],
    async initPermission() {
        let user = authManager.currentUser;
        if(user){
            const response = await axios.get("/btn-resources/omp-user")
            this.permissions = response.data
        }
    },
    checkPermission(value) {
        if (this.permissions.length > 0) {
            return this.permissions.some(item => {
                return item.btnCode === value;
            })
        } else {
            return false
        }
    },
}

export default btnResourceManager